import {createContext} from 'react';

import {noop} from 'ramda-adjunct';

export const UserContext = createContext<[string | null, (token: null | string) => void]>([
  null,
  noop,
]);
